import { ApiError, getBillingStatus } from "./api"

export const billingStatusQueryKey = ["billing", "status"] as const

export function billingStatusQueryOptions() {
  return {
    queryKey: billingStatusQueryKey,
    queryFn: getBillingStatus,
    staleTime: 0,
    retry: (count: number, error: Error) =>
      !(error instanceof ApiError && error.status < 500) && count < 2,
  }
}
